function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  cx: "59.846%",
  cy: "44.692%",
  fx: "59.846%",
  fy: "44.692%",
  r: "74.57%",
  gradientTransform: "matrix(.99746 .07118 -.1592 2.23085 .073 -.593)",
  id: "tv-kabel-internet_svg__b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ED5565",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D62839",
  offset: "100%"
})), /*#__PURE__*/React.createElement("radialGradient", {
  cx: "59.846%",
  cy: "44.692%",
  fx: "59.846%",
  fy: "44.692%",
  r: "74.576%",
  gradientTransform: "matrix(.99738 .07117 -.16195 2.19274 .074 -.576)",
  id: "tv-kabel-internet_svg__d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ED5565",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D62839",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.387%",
  y1: "35.832%",
  x2: "100%",
  y2: "91.736%",
  id: "tv-kabel-internet_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC6C6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC6C6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8A8A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.39%",
  y1: "33.027%",
  x2: "99.99%",
  y2: "100%",
  id: "tv-kabel-internet_svg__c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC6C6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC6C6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8A8A",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.918 44.605a1.68 1.68 0 01-1.615-2.141L8.05 30.257l10.08 2.588 2.747 9.619a1.68 1.68 0 01-1.615 2.14H6.918z",
  fill: "url(#tv-kabel-internet_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.393 29.128a1.7 1.7 0 01-.149 2.519c-7.466 6.125-18.506 5.705-25.48-1.268-6.97-6.97-7.393-18.013-1.267-25.48a1.7 1.7 0 012.52-.146L31.393 29.13v-.002z",
  fill: "url(#tv-kabel-internet_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.266 12.94a5.042 5.042 0 017.127 7.13",
  fill: "url(#tv-kabel-internet_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.829 5.556a10.92 10.92 0 017.743 3.205 10.923 10.923 0 013.188 8.392.871.871 0 01-1.739-.105 9.181 9.181 0 00-2.68-7.054 9.178 9.178 0 00-6.512-2.696.871.871 0 110-1.742zm11.306-.36a15.94 15.94 0 014.671 11.94.871.871 0 01-1.74-.071 14.2 14.2 0 00-4.163-10.636 14.201 14.201 0 00-10.354-4.17.871.871 0 01-.037-1.741 15.944 15.944 0 0111.623 4.679z",
  fill: "url(#tv-kabel-internet_svg__d)"
}));

function SvgTvKabelInternet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 45,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgTvKabelInternet;